import { formatPercentage } from '../../../_helpers'
import React from 'react'

export const generateFactoringFeeSummary = (fee) => {
  let typeLabelMap = {
    FeeOneTime: 'One Time Fee',
    FeeAgeRange: 'Age Range',
    FeeRecurring: 'Daily Rate',
    FeeTiered: 'Every X Day',
  }

  const formattedValue = formatPercentage(+fee.value, 2)

  let summaryMap = {
    FeeOneTime: `Charge ${formattedValue} on day ${fee.range_begin}`,
    FeeAgeRange: `Charge ${formattedValue} between day${fee.range_begin ? ` ${fee.range_begin}` : ''}${
      fee.range_end ? ` and day ${fee.range_end}` : ''
    }`,
    FeeTiered: `Charge an additional ${formattedValue} every ${
      Number(fee.range_increment) > 1 ? `${fee.range_increment} days` : 'day'
    } ${fee.range_begin ? ` beginning on day ${fee.range_begin}` : ''}${
      fee.range_end ? ` ending on day ${fee.range_end}` : ''
    }`,
    FeeRecurring: `Charge ${formattedValue} every day${
      fee.range_begin ? ` beginning on day ${fee.range_begin}` : ''
    }${fee.range_end ? ` ending on day ${fee.range_end}` : ''}`,
  }

  return (
    <div>
      <div className={'fee-name'} data-testid={`fee-name`}>
        <b>{fee.name || 'Rate'}</b>
      </div>
      <div className="fee-type" data-testid={`fee-type`}>
        <b>Type</b>: {typeLabelMap[fee.type]}
      </div>
      <div data-testid={`fee-overview`}>
        <b>Overview</b>: {summaryMap[fee.type]}
      </div>
    </div>
  )
}
